import React from 'react';
import PropTypes from 'prop-types';
import { SelectInput } from 'react-admin';

export const CleanerTypeSelectInput = ({ source, validate, ...props }) => {
  return (
    <SelectInput
      {...props}
      source={source}
      validate={validate}
      choices={[
        {
          id: 'Salarié actuel',
          name: 'resources.cleaner.form.type.current',
        },
        {
          id: 'Ancien salarié',
          name: 'resources.cleaner.form.type.former',
        },
        {
          id: 'Vivier salarial',
          name: 'resources.cleaner.form.type.applicant',
        },
      ]}
    />
  );
};

CleanerTypeSelectInput.propTypes = {
  validate: PropTypes.array,
  source: PropTypes.string.isRequired,
};

CleanerTypeSelectInput.defaultProps = {
  validate: [],
};

export default CleanerTypeSelectInput;
